import * as Long from 'long';
import { Logger } from '../metrics/logger.js';
import { ContextClassBase, ServiceIdentity } from '../service/RuntimeContext.js';

/** 会话 CoreInfo 结构 */
class ConversationCoreInfo extends ContextClassBase {
    constructor(parent, info) {
        var _a, _b;
        super(parent.ctx);
        /** Core Info 的版本号 */
        this.version = Long.ZERO;
        this.parent = parent;
        if (info !== undefined) {
            this.desc = info.desc;
            this.ext = info.ext;
            this.icon = info.icon;
            this.name = info.name;
            this.notice = info.notice;
            this.owner = (_b = (_a = info.owner) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '';
            this.version = info.info_version;
            this.secOwner = info.sec_owner;
            this.inboxType = info.inbox_type;
        }
        if (this.inboxType === undefined) {
            this.inboxType = this.resolve(ServiceIdentity.InboxType).getDefaultInboxWithoutCheck();
        }
    }
    /**
     * 会话 id
     * {@link Conversation.id}
     */
    get conversationId() {
        return this.parent.id;
    }
    /** 会话 Core Ext */
    get ext() {
        if (!this.innerExt) {
            this.innerExt = {};
        }
        return this.innerExt;
    }
    /** @internal */
    set ext(val) {
        this.innerExt = val !== null && val !== void 0 ? val : {};
    }
    mergeCore(newCore) {
        if (newCore.version.lt(this.version)) {
            Logger.ctxDebug(this.ctx, 'core info version local > online, local: ', this.version.toString(), 'new: ', newCore.version.toString());
            return this;
        }
        if (newCore.conversationId !== this.conversationId) {
            Logger.ctxDebug(this.ctx, 'core info conversation not match, local:', this.conversationId.toString(), 'new: ', newCore.conversationId.toString());
            return this;
        }
        this.version = newCore.version;
        this.name = newCore.name;
        this.desc = newCore.desc;
        this.icon = newCore.icon;
        this.notice = newCore.notice;
        this.owner = newCore.owner;
        this.secOwner = newCore.owner;
        this.innerExt = Object.assign(Object.assign({}, this.innerExt), newCore.innerExt);
        this.inboxType = newCore.inboxType;
        return this;
    }
}

export { ConversationCoreInfo };
//# sourceMappingURL=ConversationCoreInfo.js.map
